export const adStatus = {
    ACTIVE: 'active',
    BLOCKED: 'blocked',
    DISABLED: 'disabled',
    FEATURED: 'featured',
    LIMITED: 'limited',
    MODERATED: 'moderated',
    MODIFY: 'modify',
    NEW: 'new',
    OUTDATED: 'outdated',
    PENDING: 'pending',
    REJECTED: 'rejected',
    SOLD: 'sold',
    UNCONFIRMED: 'unconfirmed',
    REMOVED_BY_USER: 'removed_by_user',
    REMOVED_BY_ADMIN: 'removed_by_admin',
    REMOVED_BY_MODERATOR: 'removed_by_moderator',
    FEATURED_AUTOBOOST: 'featured_autoboost',
    FEATURED_AUTOBOOST_PTT: 'featured_autoboost_ptt',
    FEATURED_PTT: 'featured_ptt',
    AUTOBOOST_PTT: 'autoboost_ptt',
    PTT: 'ptt'
};
